<sh-form-multi-select
    [id]="id"
    [label]="isHeader ? label : undefined"
    [inOverflownContainer]="true"
    [control]="internalControl"
    [options]="options"
    [limitHeightToViewport]="true"
></sh-form-multi-select>
